import styled from 'styled-components'
import TestInfoLayoutMobile from './TestInfoLayout.mobile'
import CircleInfoArticleMobile from './circleInfo/CircleInfoArticle.mobile'
import DetailInfoArticleMobile from './detailInfo/DetailInfoArticle.mobile'
import SpreadScoreInfoArticleMobile from './spreadScoreInfo/SpreadScoreInfoArticle.mobile'
import SynthesisScoreInfoArticleMobile from './synthesisInfo/SynthesisScoreInfoArticle.mobile'
import TestUserInfoArticleMobile from './testUserInfo/TestUserInfoArticle.mobile'

const PassedInfoBoxMobile = () => {
  return (
    <StyledWrapper>
      <TestInfoLayoutMobile
        title="응시자 인적사항"
        guideText="위 결과는 서비스 참여 인원 및 가채점 결과에 따라 변동될 수 있습니다."
        className="margin-bottom-20"
      >
        <TestUserInfoArticleMobile />
      </TestInfoLayoutMobile>
      <TestInfoLayoutMobile
        title="종합 점수 결과"
        guideText="본 결과는 링커리어 합격 예측 서비스 이용자 데이터 기반으로, 실제 결과와 차이가 있을 수 있습니다."
        className="margin-bottom-40"
        isDisplayedCorrectRate
      >
        <SynthesisScoreInfoArticleMobile />
      </TestInfoLayoutMobile>
      <TestInfoLayoutMobile
        title="전체 성적 비교"
        subText="내 성적을 전체, 상위 30%, 동일 직무 응시생과 비교합니다."
        className="margin-bottom-40"
      >
        <CircleInfoArticleMobile />
      </TestInfoLayoutMobile>
      <TestInfoLayoutMobile
        title="성적 분포도"
        subText="동일한 날짜에 응시한 전체 응시생 및 동일 직무 지원자들의 성적 분포를 시각적으로 분석하여, 내 성적 위치를 파악합니다."
        className="margin-bottom-40"
      >
        <SpreadScoreInfoArticleMobile />
      </TestInfoLayoutMobile>
      <TestInfoLayoutMobile
        title="영역별 세부결과 분석"
        subText="수리 및 추리 영역에서 내 성적을 다양한 응시자 그룹과 비교하여 세부적으로 분석합니다."
      >
        <DetailInfoArticleMobile />
      </TestInfoLayoutMobile>
    </StyledWrapper>
  )
}

export default PassedInfoBoxMobile

const StyledWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
  background-color: #fafafa;

  .margin-bottom-20 {
    margin-bottom: 20px;
  }

  .margin-bottom-40 {
    margin-bottom: 40px;
  }
`
